const state = {
  isFiltersOpen: false,
  maximiumPriceRange: {
    min: null,
    max: null,
  },
};

const mutations = {
  setIsFiltersOpenState(state, value) {
    state.isFiltersOpen = value;
  },
  setPriceRangeState(state, value) {
    state.maximiumPriceRange = value;
  },
};

const actions = {
  setIsFiltersOpen({ commit }, value) {
    commit("setIsFiltersOpenState", value);
  },
  setPriceRange({ commit }, value) {
    commit("setPriceRangeState", value);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
